{
    "Profile_CommonComponents_Risks.limit": "FR: Limit",
    "Profile_CommonComponents_Risks.deductible": "FR: Deductible",
    "Profile_CommonComponents_Risks.price": "FR: Price",
    "Profile_CommonComponents_Risks.amount": "FR: Amount",
    "Profile_CommonComponents_Risks.premium_total": "FR: Premium Total",
    "Profile_CommonComponents_Risks.taxes": "FR: Taxes",
    "Profile_CommonComponents_Risks.subtotal": "FR: SubTotal",
    "Profile_CommonComponents_Risks.surcharges": "FR: Surcharges",
    "Profile_CommonComponents_Risks.discount": "FR: Discount",
    "Profile_CommonComponents_Risks.discounts": "FR: Discounts",
    "Profile_CommonComponents_Risks.fees": "FR: Fees",
    "Profile_CommonComponents_Risks.grand_total": "FR: Grand Total",
    "Profile_CommonComponents_Risks.mainCoverage": "FR: Main Coverage",
    "Profile_CommonComponents_Risks.extraProtection": "FR: Extra Protection"
}
